import React from 'react';
import { Box } from '@dripcapital/dripui-v1';
import { DAJ_COLORS } from 'utils';

type Props = {
  children: React.ReactNode;
  color?: string;
};

const SideBorderCard: React.FC<Props> = ({
  children,
  color = DAJ_COLORS.SKY_BLUE_400,
}) => {
  return (
    <Box
      _sx={{
        borderColor: color,
        borderWidth: '2px 1px 1px 1px',
        borderStyle: 'solid',
        borderRadius: '8px',
        padding: '16px',
      }}
    >
      {children}
    </Box>
  );
};

export default SideBorderCard;
